// import React, { useContext, useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { addToCart } from '../../redux/cartslice';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import Context from '../../Context/Context';
// import Loader from '../../ApiCheck/Loader';
// import { baseUrl } from '../../ApiCheck/Constant';

// const ProductDetails = () => {
//   const location = useLocation();
//   const [loading, setLoading] = useState(false);

//   const { product } = location.state;
//   const user = useSelector((state) => state.user);
//   const { fetchCartCount } = useContext(Context);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!user.isAuth) {
//       navigate('/');
//     }
//   }, [user, navigate]);

//   const addToCartHandler = async (product) => {
//     setLoading(true); 
//     try {
//       if (user.isAuth) {
//         dispatch(addToCart(product));
//         const payload = { ...product, quantity: 1 };
//         await axios.post(`${baseUrl}/api/addtocart`, payload);
//         fetchCartCount();
//         toast.success("Product added to cart", { position: 'top-center', autoClose: 3000 });
//       } else {
//         toast.error("Please Login...", { position: 'top-center', autoClose: 3000 });
//       }
//     } catch (error) {
//       toast.error("Failed to add product to cart", { position: 'top-center', autoClose: 3000 });
//     } finally {
//       setLoading(false); 
//     }
//   };

//   const style = {
//     width: "50%",          
//     height: "100%",       
//     objectFit: "cover",
//     margin: "auto"
//   };

//   return (
//     <div className="container product-details">
//       {loading ? ( 
//         <Loader />
//       ) : (
//         <>
//           {product ? (
//             <div className="row">
//               <div className="col-md-4 col-sm-6 mx-auto my-3">
//                 <div className="card h-100">
//                   <img
//                     src={product.image}
//                     className="card-img-top"
//                     alt={product.name}
//                     style={style}
//                   />
//                   <div className="card-body d-flex flex-column">
//                     <h5 className="card-title">{product.name}</h5>
//                     <p className="card-text">{product.description}</p>
//                     <p className="card-price"><strong>Price: </strong>${product.price}</p>
//                     <button type="button" className="btn btn-dark btn-sm"  onClick={() => addToCartHandler(product)}>
//                           Add to Cart
//                         </button>
                    
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ) : (
//             <div className="mt-3">
//               <p>Loading product details...</p>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default ProductDetails;
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../../redux/cartslice';
import axios from 'axios';
import { toast } from 'react-toastify';
import Context from '../../Context/Context';
import Loader from '../../ApiCheck/Loader';
import { baseUrl } from '../../ApiCheck/Constant';

const ProductDetails = () => {
  const location = useLocation();
  const { product } = location.state;
  const [loading, setLoading] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { fetchCartCount } = useContext(Context);

  useEffect(() => {
    if (!user.isAuth) {
      navigate('/');
    }
  }, [user, navigate]);

  const incrementQty = () => {
    setQuantity(prev => prev + 1);
  };

  const decrementQty = () => {
    if (quantity > 1) setQuantity(prev => prev - 1);
  };

  const addToCartHandler = async () => {
    setLoading(true);
    try {
      if (user.isAuth) {
        const cartItem = { ...product, quantity };
        dispatch(addToCart(cartItem));
        await axios.post(`${baseUrl}/api/addtocart`, cartItem);
        fetchCartCount();
        toast.success("Product added to cart", { position: 'top-center', autoClose: 3000 });
      } else {
        toast.error("Please Login...", { position: 'top-center', autoClose: 3000 });
      }
    } catch (error) {
      toast.error("Failed to add product to cart", { position: 'top-center', autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  const imageStyle = {
    width: "100%",
    height: "300px",
    objectFit: "contain",
    padding: "10px",
  };

  return (
    <div className="container py-4">
      {loading ? (
        <Loader />
      ) : (
        <>
          {product ? (
            <div className="row">
              <div className="col-md-6 text-center">
                <img src={product.image} alt={product.name} style={imageStyle} className="img-fluid border rounded" />
              </div>
              <div className="p-2 col-md-6">
                <h3>{product.name}</h3>
                <p>{product.description}</p>
                <p><strong>Price:</strong> ${product.price}</p>
                <p><strong>Category:</strong> {product.category || "N/A"}</p>
                <p><strong>Brand:</strong> {product.brand || "N/A"}</p>
                <p><strong>Stock:</strong> {product.stock || "Available"}</p>

                <div className="d-flex align-items-center my-3">
                  <button className="btn btn-outline-secondary" onClick={decrementQty} disabled={quantity === 1}>−</button>
                  <span className="px-3">{quantity}</span>
                  <button className="btn btn-outline-secondary" onClick={incrementQty}>+</button>
                </div>

                <button className="btn btn-dark" onClick={addToCartHandler}>
                  Add {quantity} to Cart
                </button>
              </div>
            </div>
          ) : (
            <p>Loading product details...</p>
          )}
        </>
      )}
    </div>
  );
};

export default ProductDetails;
